import { ErrorMessage as ErrorMessageCore } from 'formik'

import styled from 'styled-components';

export const Container = styled.span`
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
`;


function ErrorMessage(props) {
  return <ErrorMessageCore {...props} component={Container} className="invalid-feedback" role="alert" />;
}

export default ErrorMessage;
